<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container >
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-model-item :label="language['basedata.province']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="province">
              <a-select  show-search  optionFilterProp="label" :placeholder="language['common.pleaseInput']+language['basedata.province']" v-model="model.province" :disabled="this.disabled"
               @change="backProvince" >
                <a-select-option
                  v-for="d in provinceOptions"
                  :key="d.id"
                  :value="d.id"
                  :label="d.name">
                  {{ d.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['basedata.city']"  :labelCol="labelCol" :wrapperCol="wrapperCol" prop="city">
              <a-select show-search optionFilterProp="label" :placeholder="language['common.pleaseInput']+language['basedata.city']"  v-model="model.city" :disabled="this.disabled">
                <a-select-option
                  v-for="d in cityOptions"
                  :key="d.id"
                  :value="d.id"
                  :label="d.name">
                  {{ d.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['factory.no']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="factoryCode">
              <a-input v-model="model.factoryCode" :placeholder="language['common.pleaseInput']+language['factory.no']" :disabled="this.disabled" ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['factory.name']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="factoryName">
              <a-input v-model="model.factoryName" :placeholder="language['common.pleaseInput']+language['factory.name']"  style="width: 80%" :disabled="this.disabled"></a-input>
              <a-button @click="languageModelOpen('EpBdFactory','factoryName',nameLanguages)" type="primary"  style="left: 3%" >{{language['common.language']}}</a-button>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['factory.address']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="address">
              <a-input v-model="model.address" :placeholder="language['common.pleaseInput']+language['factory.address']" :disabled="this.disabled" ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['system.longitude']" :labelCol="labelCol" :wrapperCol="wrapperCol" >
              <a-input v-model="model.longitude" :placeholder="language['common.pleaseInput']+language['system.longitude']" :disabled="this.disabled" ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['system.latitude']" :labelCol="labelCol" :wrapperCol="wrapperCol" >
              <a-input v-model="model.latitude" :placeholder="language['common.pleaseInput']+language['system.latitude']" :disabled="this.disabled" ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['system.altitude']" :labelCol="labelCol" :wrapperCol="wrapperCol" >
              <a-input v-model="model.altitude" :placeholder="language['common.pleaseInput']+language['system.altitude']" :disabled="this.disabled" ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['system.isVirtual']" :labelCol="labelCol" :wrapperCol="wrapperCol" >
              <a-radio-group v-model="model.virtual" :disabled="this.disabled">
                <a-radio value="1" >
                  {{language['common.yes']}}
                </a-radio>
                <a-radio value="0" >
                  {{language['common.no']}}
                </a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          
        </a-row>
      </a-form-model>
    </j-form-container>
    <language-model ref="languageModel" @ok="languageOk"></language-model>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'
  import LanguageModel from "@/components/LanguageModel"

  export default {
    name: 'EpFactoryForm',
    components: {
      LanguageModel
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model:{
         },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        pCategoryOptions:[],
        provinceOptions:[],
        cityOptions:[],
        url: {
          list: "/sys/province/loadTreeDataBylevel",
          childList: "/sys/province/childList",
          add: "/sys/epFactory/add",
          edit: "/sys/epFactory/edit",
          queryById: "/sys/epFactory/queryById"
        },
        nameLanguages:[],
      }
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
      validatorRules(){
        if(this.language){
          return {
            province:[{ required: true, message: this.language['common.pleaseInput']+this.language['basedata.province']},],
            city:[{ required: true, message: this.language['common.pleaseInput']+this.language['basedata.city']},],
            factoryCode: [
              { required: true, message: this.language['common.pleaseInput']+this.language['factory.no']},
              { validator: (rule, value, callback) => validateDuplicateValue('ep_bd_factory', 'factory_code', value, this.model.id,'0', callback)},
              {max: 50, message: this.language['factory.length'], trigger: 'blur'}
           ],
           factoryName: [
              { required: true, message: this.language['common.pleaseInput']+this.language['factory.name']},
              { validator: (rule, value, callback) => validateDuplicateValue('ep_bd_factory', 'factory_name', value, this.model.id,'0', callback)},
              {max: 50, message: this.language['factory.length'], trigger: 'blur'}
           ],
            address: [
              {max: 255, message: this.language['system.lengthExceedslimit'], trigger: 'blur'}
            ],
          }
        }
      },
      formDisabled(){
        return this.disabled
      },
    },
    created () {
       //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
      this.loadData();
    },
    methods: {
      languageModelOpen(dataTable,dataColumn,languagelist){
        this.$refs.languageModel.edit("platform",dataTable,dataColumn,this.model.id,languagelist,this.disabled);
      },
      languageOk(map){
        if(map&&map.dataColumn == 'factoryName'){
          this.nameLanguages = map.languagelist;
        }
      },
      loadData(){
        this.loading = true
        let params = {level:10};
        getAction(this.url.list,params).then(res=>{
          if(res.success){
            let result = res.result;              
              this.provinceOptions = result.map(item=>{
                  let c ={id:item.id, name: item.name}
                  return c;
              });   
          }else{
            this.$message.warning(res.message)
          }
        }).finally(()=>{
          this.loading = false
        })
      },
      backProvince()
      {
        this.cityOptions=[];  
        this.$set(this.$data, 'model', {
            ...this.model,
            city: ''
        });
        let params = {pid:this.model.province,pageNo:1,pageSize:100000};
        getAction(this.url.childList,params).then(res=>{
            if(res.success){
              let result = res.result;                 
                this.cityOptions = result.map(item=>{
                  if(item.pid == this.model.province)
                  {
                      let c ={id:item.id, name: item.name}
                      return c;
                  }
                });    
            }else{
              this.$message.warning(res.message)
            }
          })
      },
      add () {
        this.edit(this.modelDefault);
      },
      initLanguagetemp(dataTable,dataColumn,dataId){
        getAction("/sys/syslanguagedata/querylistby", {applicationCode:"platform",dataTable:dataTable,dataColumn:dataColumn,dataId:dataId}).then((res)=> {
          if (res.success) {
            this.nameLanguages = res.result;
          }
        })
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
        //加载城市数据
        let params = {pid:this.model.province,pageNo:1,pageSize:100000};
        getAction(this.url.childList,params).then(res=>{
            if(res.success){
              let result = res.result;                 
                this.cityOptions = result.map(item=>{
                  if(item.pid == this.model.province)
                  {
                      let c ={id:item.id, name: item.name}
                      return c;
                  }
                });    
            }else{
              this.$message.warning(res.message)
            }
          })
        this.initLanguagetemp('EpBdFactory','factoryName',record.id)
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                this.nameLanguages.forEach(item=>{
                  if(!item.dataId){
                    item.dataId = res.result.id;
                  }
                })
                httpAction("/sys/syslanguagedata/saveSysLanguageDataList",this.nameLanguages,"post").then((res)=>{
                  if(res.success){
                    that.$message.success(res.message);
                    that.$emit('ok');
                  }
                })
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
    }
  }
</script>